import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-fluid p-m-4" }
const _hoisted_2 = {
  for: "treeType",
  class: "kn-material-input-label",
  "aria-label": "dropdown"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_LovsManagementSimpleDatatable = _resolveComponent("LovsManagementSimpleDatatable")
  const _component_LovsManagementTree = _resolveComponent("LovsManagementTree")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: _ctx.$t('managers.lovsManagement.test'),
    visible: _ctx.visible,
    modal: true,
    class: "testLovDialog p-fluid kn-dialog--toolbar--primary",
    closable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.onSave,
        disabled: _ctx.buttonDisabled
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", null, [
          _createVNode("span", null, [
            _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('managers.lovsManagement.testTreeType')) + " * ", 1),
            _createVNode(_component_Dropdown, {
              id: "treeType",
              class: "kn-material-input",
              modelValue: _ctx.treeListTypeModel.LOVTYPE,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.treeListTypeModel.LOVTYPE = $event)),
              options: _ctx.lovsManagementTestDialogDescriptor.treeTypes,
              optionLabel: "name",
              optionValue: "value",
              onChange: _ctx.resetValues
            }, null, 8, ["modelValue", "options", "onChange"])
          ])
        ])
      ]),
      (_ctx.treeListTypeModel.LOVTYPE === 'simple')
        ? (_openBlock(), _createBlock(_component_LovsManagementSimpleDatatable, {
            key: 0,
            tableData: _ctx.model,
            treeListTypeModel: _ctx.treeListTypeModel,
            onModelChanged: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onModelChange($event)))
          }, null, 8, ["tableData", "treeListTypeModel"]))
        : (_openBlock(), _createBlock(_component_LovsManagementTree, {
            key: 1,
            listData: _ctx.model,
            treeModel: _ctx.treeModel,
            onModelChanged: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onTreeModelChange($event)))
          }, null, 8, ["listData", "treeModel"]))
    ]),
    _: 1
  }, 8, ["header", "visible"]))
}